export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/fetch-and-parse-countries.9ab22e02.worker.js");
}
